import { render, staticRenderFns } from "./ListImageGroups.vue?vue&type=template&id=a080ba56&scoped=true&"
import script from "./ListImageGroups.vue?vue&type=script&lang=js&"
export * from "./ListImageGroups.vue?vue&type=script&lang=js&"
import style0 from "./ListImageGroups.vue?vue&type=style&index=0&id=a080ba56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a080ba56",
  null
  
)

export default component.exports